// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c2091dd7","213":"21d1bcf5","455":"5b8a60cf"}[chunkId] + ".chunk.js";
};